import { Parser } from 'json2csv';

const timesArray = [
  { id: 1, label: '9:00 AM' },
  { id: 2, label: '9:15 AM' },
  { id: 3, label: '9:30 AM' },
  { id: 4, label: '9:45 AM' },
  { id: 5, label: '10:00 AM' },
  { id: 6, label: '10:15 AM' },
  { id: 7, label: '10:30 AM' },
  { id: 8, label: '10:45 AM' },
  { id: 9, label: '11:00 AM' },
  { id: 10, label: '11:15 AM' },
  { id: 11, label: '11:30 AM' },
  { id: 12, label: '11:45 AM' },
  { id: 13, label: '12:00 PM' },
  { id: 14, label: '12:15 PM' },
  { id: 15, label: '12:30 PM' },
  { id: 16, label: '12:45 PM' },
  { id: 17, label: '1:00 PM' },
  { id: 18, label: '1:15 PM' },
  { id: 19, label: '1:30 PM' },
  { id: 20, label: '1:45 PM' },
  { id: 21, label: '2:00 PM' },
  { id: 22, label: '2:15 PM' },
  { id: 23, label: '2:30 PM' },
  { id: 24, label: '2:45 PM' },
  { id: 25, label: '3:00 PM' },
  { id: 26, label: '3:15 PM' },
  { id: 27, label: '3:30 PM' },
  { id: 28, label: '3:45 PM' },
  { id: 29, label: '4:00 PM' },
  { id: 30, label: '4:15 PM' },
  { id: 31, label: '4:30 PM' },
  { id: 32, label: '4:45 PM' },
  { id: 33, label: '5:00 PM' },
  { id: 34, label: '5:15 PM' },
  { id: 35, label: '5:30 PM' },
  { id: 36, label: '5:45 PM' },
  { id: 37, label: '6:00 PM' },
  { id: 38, label: '6:15 PM' },
  { id: 39, label: '6:30 PM' },
  { id: 40, label: '6:45 PM' },
  { id: 41, label: '7:00 PM' },
  { id: 42, label: '7:15 PM' },
  { id: 43, label: '7:30 PM' },
  { id: 44, label: '7:45 PM' },
  { id: 45, label: '8:00 PM' },
  { id: 46, label: '8:15 PM' },
  { id: 47, label: '8:30 PM' },
  { id: 48, label: '8:45 PM' },
  { id: 49, label: '9:00 PM' },
];

const today = new Date();
const date =
  new Date().getFullYear() +
  '-' +
  (new Date().getMonth() + 1) +
  '-' +
  new Date().getDate();
const filename = `tours-requests-${date}`;
const fields = [
  'id',
  'date',
  'time',
  'requestorName',
  'requestorTitle',
  'requestorTeam',
  'requestorEmail',
  'requestorPhone',
  'requestorCompany',
  'tourType',
  'tourTypeName',
  'tourPurpose',
  'numAttendees',
  'catering',
  'tourContact',
  'tourContactName',
  'tourContactEmail',
  'tourContactPhone',
  'tourNeeded',
  'notes',
  'bookingId',
  'bookingStatus',
  'denyReason',
  'tourGuideFirstName',
  'tourGuideLastName',
  'tourGuideEmail',
];

const getTimeLabel = id =>
  timesArray.find(time => time.id === Number(id))?.label || '';

const formatCalendarDate = calendar => {
  if (!calendar?.year || !calendar?.month || !calendar?.day) {
    return '';
  }

  return `${calendar.month}/${calendar.day}/${calendar.year}`;
};

const formatCalendarTime = (calendar, type) => {
  if (!calendar?.times?.length) {
    return '';
  }

  const startTime = getTimeLabel(calendar.times[2]);

  if (type === 'event') {
    const endTime = getTimeLabel(calendar.times[calendar.times.length - 3]);
    return endTime ? `${startTime} to ${endTime}` : startTime;
  }

  return startTime;
};

const formatExportRow = tour => ({
  id: tour?.id || '',
  requestorName: tour?.requestorName || '',
  requestorTitle: tour?.requestorTitle || '',
  requestorTeam: tour?.requestorTeam || '',
  requestorEmail: tour?.requestorEmail || '',
  requestorPhone: tour?.requestorPhone || '',
  requestorCompany: tour?.requestorCompany || '',
  tourType: tour?.tourType || '',
  tourTypeName: tour?.tourTypeName || '',
  tourPurpose: tour?.tourPurpose || '',
  numAttendees: tour?.numAttendees || '',
  catering: tour?.catering || '',
  tourContact: tour?.tourContact || '',
  tourContactName: tour?.tourContactName || '',
  tourContactEmail: tour?.tourContactEmail || '',
  tourContactPhone: tour?.tourContactPhone || '',
  tourNeeded: tour?.tourNeeded || '',
  notes: tour?.notes || '',
  bookingId: tour?.booking?.tourId || '',
  bookingStatus: tour?.booking?.status || '',
  denyReason: tour?.booking?.denyReason || '',
  tourGuideFirstName: tour?.tourGuideConfirmed?.firstName || '',
  tourGuideLastName: tour?.tourGuideConfirmed?.lastName || '',
  tourGuideEmail: tour?.tourGuideConfirmed?.email || '',
  date: formatCalendarDate(tour?.calendar),
  time: formatCalendarTime(tour?.calendar, tour?.type),
});

export const exportCsv = async (toursList, setExportUrl) => {
  const opts = { fields };
  try {
    const parser = await new Parser(opts);
    const csv = await parser.parse((toursList || []).map(formatExportRow));
    const blob = await new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = await URL.createObjectURL(blob);
    setExportUrl(url);
  } catch (err) {
    console.error(err);
  }
};
